export { default as Achievement } from "./achievement";
export { default as NewsHome } from "./news-home";
export { default as MainContent } from "./main-content";
export { default as ContactForm } from "./contact-form";
export { default as ProductCarousel } from "./product-carousel";
export { default as VideoHome } from "./video-home";
